import React, { Fragment, useEffect, useState } from 'react';
import {
  Box,
  Collapse,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
  TextField,
  InputAdornment
} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import Button from 'components/CustomButtons/Button.js';
import ButtonDelete from 'hooks/ButtonDelete';
import { Add, KeyboardArrowDown, KeyboardArrowUp, Search } from '@material-ui/icons';
import { wsGetAll, wsCreate } from 'services/WService';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import SaleForces from './SaleForces';
import { Autocomplete } from '@material-ui/lab';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const useRowStyles = makeStyles({
  root: {
    '& > *': { borderBottom: 'unset' }
  }
});

const Detail = ({ saleForce, reload, showNotify, canals = [] }) => {
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();

  const [canal, setCanal] = useState(canals[0]);
  useEffect(() => {
    setCanal(canals[0]);
  }, [saleForce]);

  async function addDetail(canalId) {
    let response = await wsCreate('base/sale-force-detail', {
      base_seller_id: saleForce.base_seller_id,
      base_sale_force_id: saleForce.id,
      base_canal_id: canalId
    });
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <Fragment>
      <TableRow className={classes.root} style={{ backgroundColor: open ? '#fef3ff' : '' }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{`${saleForce.base_zone_code} - ${saleForce.base_zone_description}`}</TableCell>
        <TableCell>{`${saleForce.WhsCode} - ${saleForce.WhsName}`}</TableCell>
        <TableCell>
          {`${saleForce.base_bureau_code} - ${saleForce.base_bureau_description}`}
        </TableCell>
        <TableCell>{saleForce.state === 'A' ? 'Activo' : 'Inactivo'}</TableCell>
        <TableCell align="center">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FormControl fullWidth margin="normal" size="small" style={{ marginTop: 0 }}>
              <Select
                value={canal?.id || ''}
                inputProps={{
                  name: 'base_canal_id',
                  onChange: (e) => setCanal({ ...canal, base_canal_id: e.target.value })
                }}
              >
                {canals.length == 0 ? (
                  <MenuItem value="" disabled>
                    Canales no disponibles
                  </MenuItem>
                ) : undefined}
                {canals.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_STORE}>
              <Button
                size="sm"
                justIcon
                round
                color="success"
                style={{ marginLeft: '7px' }}
                disabled={canals.length == 0}
                onClick={() => addDetail(canal.id)}
              >
                <Add />
              </Button>
            </AllowedGuard>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Cód. canal</TableCell>
                    <TableCell>Nombre canal</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell align="center">Eliminar</TableCell>
                  </TableRow>
                </TableHead>
                <SubDetail details={saleForce?.details || []} reload={reload} canals={canals} />
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

const SubDetail = ({ details, reload }) => {
  return (
    <TableBody>
      {details.map((item, i) => (
        <TableRow key={item.id}>
          <TableCell component="th" scope="row">
            {i + 1}
          </TableCell>
          <TableCell>{item.base_canal_code}</TableCell>
          <TableCell>{item.base_canal_description}</TableCell>
          <TableCell>{item.state === 'A' ? 'Activo' : 'Inactivo'}</TableCell>
          <TableCell align="center">
            <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_DELETED}>
              <ButtonDelete
                entity="base/sale-force-detail"
                id={item.id}
                reload={reload}
                style={{ height: 0 }}
              />
            </AllowedGuard>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

const ModalDetail = ({ seller, handleChange }) => {
  const [openModalSF, setOpenModalSF] = useState(false);
  const [selectSF, setSelectSF] = useState({});
  const [canals, setCanals] = useState([]);

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  useEffect(() => {
    listCanals();
  }, []);

  useEffect(() => {
    if (selectSF.id) handleChange('base_sale_force_id', selectSF.id);
  }, [selectSF]);

  return (
    <>
      <ModalFull title="Fuerzas de venta" open={openModalSF} setOpen={setOpenModalSF}>
        <SaleForces setSelectSF={setSelectSF} setOpenModalSF={setOpenModalSF} />
      </ModalFull>

      <TextField label="Vendedor" fullWidth margin="normal" value={seller.SlpName || ''} readOnly />
      <TextField
        key={openModalSF + selectSF}
        label="Fuerza venta"
        value={
          selectSF.id
            ? `Zona: ${selectSF.base_zone_code} - Almacén: ${selectSF.WhsCode} - Mesa: ${selectSF.base_bureau_code}`
            : ''
        }
        margin="normal"
        size="small"
        /* inputProps={{ readOnly: true }} */
        onKeyPress={() => false}
        InputProps={{
          startAdornment: (
            <InputAdornment
              style={{ cursor: 'pointer', color: '#07c107' }}
              onClick={() => setOpenModalSF(true)}
              position="start"
            >
              <Search />
            </InputAdornment>
          )
        }}
        placeholder="seleccione una fuerza venta..."
        required
        fullWidth
      />
      <Autocomplete
        disableClearable
        size="small"
        options={canals}
        getOptionLabel={(option) => option.description}
        renderInput={(params) => <TextField {...params} label="canal" margin="normal" required />}
        onChange={(e, item) => handleChange('base_canal_id', item.id)}
      />
    </>
  );
};

export { Detail, ModalDetail };
